import { FC } from 'react';
import { useController } from 'react-hook-form';
import { TimePicker, TimelyTimePickerProps } from '../base';

interface RhfTimePickerProps extends TimelyTimePickerProps {
  control: any;
  name: string;
}

const RhfTimePicker: FC<RhfTimePickerProps> = ({
  control,
  name,
  label,
  placeholder,
  fullWidth,
  ...otherProps
}) => {
  const {
    field: { onChange, onBlur, value, ref },
    fieldState: { error }
  } = useController({
    name,
    control,
    defaultValue: ''
  });

  return (
    <TimePicker
      label={label}
      helperText={error?.message}
      placeholder={placeholder}
      error={error ? true : false}
      onChange={onChange} // send value to hook form
      onBlur={onBlur} // notify when input is touched/blur
      value={value} // input value
      name={name} // send down the input name
      inputRef={ref} // send input ref, so we can focus on input when error appear
      fullWidth={fullWidth}
      {...otherProps}
    />
  );
};

export { RhfTimePicker };
